
import React from 'react';
import { AutomaticSigninPopup } from './AMCAuth';

export default class AMCSignInPage extends React.Component {
	constructor(props) {
		super(props);
		this.state = {};
	}
	render() {
		let { submit_button_label } = this.props;
		return	(
			<AutomaticSigninPopup submit_button_label={submit_button_label || "Make it so"} {...this.props}  />
		)
	}
}



// WEBPACK FOOTER //
// ./src/AMCSignInPage.js